module.exports = __webpack_public_path__ + "./images/79e1f3ef684ea30bde9d7ee1a2a12921.webp";